<template>
    <ul>
        <p v-bind:style="{ color: messageColor }">{{message}}</p>
        <template v-if="node_env === 'development' && canEdit === true">
            <small><kbd>lastTreeId: {{tree.lastTreeId}} - node_env: '{{node_env}}' - canEdit: {{canEdit}}</kbd></small><br>
            <small><kbd v-if="cutedNode !== null">cutedNode: {{cutedNode.id || null}} - cutedParent: {{cutedParent.id || null}}</kbd></small><br>
        </template>
        <template v-if="canEdit === true && cutedNode !== null">
            <span class="button button-primary" @click="undoCut">Undo Cut</span>
        </template>
        <link-tree-node v-for="node in tree.children" v-bind:key="node.id" :node='node' :can-edit="canEdit"></link-tree-node>
    </ul>
</template>

<script>
import LinkTreeNode from '@/components/LinkTreeNode'

/* ***
// const LINKS_URL = '../static/data/javascript-links.json'
const LINKS_URL = 'static/data/javascript-links.json'

let WEBAPI_URL = ''
if (process.env.NODE_ENV === 'production') {
    // $$$
    this.id ? WEBAPI_URL = 'static/lib/api.php?id=' + this.id : WEBAPI_URL = 'static/lib/api.php?id=undefined'
} else {
    if (this && this.id) {
        WEBAPI_URL = 'http://localhost/static/lib/api.php?id=' + this.id
    } else {
        WEBAPI_URL = 'http://localhost/static/lib/api.php?id=undefined'
    }
} *** */

export default {
    name: 'LinkTree',
    props: ['can-edit', 'id'], // $$$ 'tree', 'url',
    components: { 'link-tree-node': LinkTreeNode },
    mounted () {
        // HTTP get tree data from JSON file
        this.getLinks()
        // Register event listener(s)
        this.$on('update-link-node', this.onUpdateLinkNode)
        this.$on('onCutChildNode', this.onCutChildNode)
        this.$on('onDragStart', this.onDragStart)
        this.$on('onDropNode', this.onDropNode)
    },
    data: function () {
        return {
            message: '',
            tree: {},
            node_env: process.env.NODE_ENV,
            // Cut & Paste node and parent
            cutedNode: null,
            cutedParent: null,
            // Drag & Drop nodes and parents
            dragedNode: null,
            dragedParent: null,
            dropNode: null,
            dropParent: null
        }
    },
    methods: {
        getLinks: function () {
            this.webapi$anonymousGetLinks()
                .then(response => {
                    if (response.ok === true) {
                        this.tree = response.body
                    }
                })
                .catch(response => {
                    console.log('getLinks.$http.get CATCH: response'); console.dir(response)
                })
        },
        storeLinksJson: function (links) {
            let userId = this.$parent.$parent.current.user === null ? null : this.$parent.$parent.current.user.UserId
            let token = this.$parent.$parent.current.user === null ? null : this.$parent.$parent.current.user.token

            return this.webapi$write_tree(userId, token, links)
                .then(response => {
                    if (response.body.errors.length > 0) {
                        console.log('LinkTree.storeLinksJson - THEN: errors[]: ' + 'Transaktion fehl geschlagen! Daten wurden nicht gespeichert.')
                        // console.dir(response)
                        this.messageColor = '#e00056'
                        this.message = 'Transaktion fehl geschlagen! Daten wurden nicht gespeichert.'
                    } else {
                        console.log('LinkTree.storeLinksJson - THEN: ' + 'Transaktion wurde erfolgreich abgeschlossen.')
                        // return 'Transaktion wurde erfolgreich abgeschlossen.'
                        this.messageColor = '#42b993'
                        this.message = 'Transaktion wurde erfolgreich abgeschlossen.'
                    }
                })
                .catch(response => {
                    console.log('LinkTree.storeLinksJson - CATCH: Transaktion fehl geschlagen! Daten wurden nicht gespeichert.')
                    console.dir(response)
                    // throw new Error('Transaktion fehl geschlagen! Daten wurden nicht gespeichert.')
                    // return 'Transaktion fehl geschlagen! Daten wurden nicht gespeichert.'
                    this.messageColor = '#e00056'
                    this.message = 'Transaktion fehl geschlagen! Daten wurden nicht gespeichert.'
                })
        },
        // *** Event handler ***
        onUpdateLinkNode: function (crudMode, node, parent) {
            //
            function renumberChildIDs (lastId, treeItem) {
                lastId++
                treeItem.id = lastId
                if (treeItem.children) {
                    for (let i = 0; i < treeItem.children.length; i++) {
                        lastId = renumberChildIDs(lastId, treeItem.children[i])
                    }
                }
                return lastId
            }

            // console.log('LinkTree.onUpdateLinkNode node: ' + node); console.dir(node)
            console.log(`LinkTree.onUpdateLinkNode node:
            CRUD-mode   : ${crudMode}
            node:     id: ${node.id || null} - title: ${node.title || null}
            parent:   id: ${parent.id || null} - title: ${parent.title || null}`)

            this.message = 'Transaktion läuft...'

            // Set ID for new created tree nodes
            if (crudMode === 'create') {
                this.tree.lastTreeId = renumberChildIDs(100000, this.tree)
                //
                this.tree.lastTreeId++
                node.id = this.tree.lastTreeId
            } else if (crudMode === 'cut') {
                this.cutedNode = node
                this.cutedParent = parent
                this.message = ''
                return // DO NOT STORE THE TREE !!!
            } else if (crudMode === 'paste') {
                parent.children.push(this.cutedNode)
                this.cutedNode = null
                this.cutedParent = null
            }

            // Finaly, store the tree.
            this.storeLinksJson(this.tree)
        },
        onCutChildNode: function (cutedNode) {
            console.log(`LinkTree.onCutChildNode:
            cutedNode.(id/title): ${cutedNode.id} / ${cutedNode.title}`)

            let cutedNodeIndex = this.tree.children.findIndex(element => { return element.id === cutedNode.id })
            console.log(`LinkTree.onCutChildNode cutedNodeIndex: ${cutedNodeIndex}`)

            if (cutedNodeIndex >= 0) {
                this.tree.children.splice(cutedNodeIndex, 1)
                this.crudMode = 'cut'
                this.$emit('update-link-node', this.crudMode, cutedNode, this.tree)
            }
        },
        undoCut: function () {
            console.log(`LinkTree.undoCut:
            this.cutedNode.(id/title): ${this.cutedNode.id} / ${this.cutedNode.title}`)

            if (this.cutedNode !== null && this.cutedParent !== null) {
                this.cutedParent.children.push(this.cutedNode)
                this.cutedParent = null
                this.cutedNode = null
            }
        },
        onDragStart: function (dragedNode, dragedParent) {
            if (dragedParent === null) {
                // $$$ check if this.node is direct parent of dragedNode
                dragedParent = this.tree
            }
            this.dragedNode = dragedNode
            this.dragedParent = dragedParent

            console.log(`LinkTree.onDragStart:
            dragedNode.(id/title)  : ${dragedNode.id} / ${dragedNode.title}
            dragedParent.(id/title): ${dragedParent ? dragedParent.id : 'null'} / ${dragedParent ? dragedParent.title || '(root)' : 'null'}`)
        },
        onDropNode: function (dropNode, dropParent) {
            //
            function isRecursiveChild (target, search) {
                if (target.children && target.children.length >= 0) {
                    if (target.children.findIndex(element => { return element === search }) >= 0) {
                        return true
                    }
                    for (let i = 0; i < target.children.length; i++) {
                        if (isRecursiveChild(target.children[i], search) === true) {
                            return true
                        }
                    }
                }
                return false
            }

            function cleanUp (self) {
                self.dragedNode = null
                self.dragedParent = null
                self.dropNode = null
                self.dropParent = null
            }

            if (dropParent === null) {
                // $$$ check if this.node is direct parent of dropNode
                dropParent = this.tree
            }
            this.dropNode = dropNode
            this.dropParent = dropParent

            console.log(`LinkTree.onDropNode:
            dropNode.(id/title)  : ${dropNode.id} / ${dropNode.title}
            dropParent.(id/title): ${dropParent ? dropParent.id : 'null'} / ${dropParent ? dropParent.title || '(root)' : 'null'}`)

            this.message = 'Transaktion läuft...'

            let dragedNodeIndex = this.dragedParent.children.findIndex(element => { return element.id === this.dragedNode.id })
            let dropNodeIndex = this.dropParent.children.findIndex(element => { return element.id === this.dropNode.id })
            let isSameParent = this.dragedParent === this.dropParent
            console.log(`LinkTree.onDropNode
            dragedNodeIndex: ${dragedNodeIndex}
            dropNodeIndex  : ${dropNodeIndex}
            same parent    : ${isSameParent}`)

            // Relocate draged-node to drop-node place.
            if (isSameParent === true) {
                if (dragedNodeIndex > dropNodeIndex) {
                    // Shift node from bottom / up
                    let xNode = this.dragedParent.children.splice(dragedNodeIndex, 1)
                    let dropNodeIndex = this.dropParent.children.findIndex(element => { return element.id === this.dropNode.id })
                    this.dropParent.children.splice(dropNodeIndex, 0, xNode[0])
                    console.log(`LinkTree.onDropNode: xchange draged-/drop-node in same parent - bottom / up.`)
                } else {
                    // Shift node top / down
                    this.dropParent.children.splice(dropNodeIndex + 1, 0, this.dragedNode)
                    let dragedNodeIndex = this.dropParent.children.findIndex(element => { return element.id === this.dragedNode.id })
                    this.dragedParent.children.splice(dragedNodeIndex, 1)
                    console.log(`LinkTree.onDropNode: xchange draged-/drop-node in same parent - top / down.`)
                }
            } else {
                // Avoid copying if dropParent is child of dragedParent !!
                if (isRecursiveChild(this.dragedNode, this.dropNode) === true) {
                    this.message = 'Ups(!), Vater-Element kann nicht in sein eigenes Kind-Element verschoben werden!'
                    cleanUp(this)
                    return
                }
                let xNode = this.dragedParent.children.splice(dragedNodeIndex, 1)
                this.dropParent.children.splice(dropNodeIndex, 0, xNode[0])
                console.log(`LinkTree.onDropNode: xchange draged-/drop-node accross parents.`)
            }

            this.storeLinksJson(this.tree)
                .then(message => { this.message = message })
                .catch(message => { this.message = message })

            cleanUp(this)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/LinkTree.vue